import { useContext } from "react";
import {
  TokenInvitationContext,
  TokenInvitationState,
} from "../../providers/TokenInvitationContext";

export function useTokenInvitationCtx(): TokenInvitationState {
  const tokenInvitationCtx = useContext(TokenInvitationContext);

  if (!tokenInvitationCtx) {
    throw new Error(
      "useTokenInvitationCtx must be used within a TokenInvitationProvider"
    );
  }

  return tokenInvitationCtx;
}
